import { importAll } from '@/utils/utils.js'

const routeModules = importAll(
  require.context('@/router/modules', false, /\.js$/)
)
const routes = routeModules.reduce(
  (finallRoutes, routerModule) =>
    finallRoutes.concat(routerModule.module),
  []
)

export default routes
